import  "./Finland2023.css"

const Finland2023 = ()=>{
     
    return (
    <>        
     
    </>
    )
}

export default Finland2023;